import { useEffect, useState, useCallback } from 'react'
import { useAppSelector } from "../../../../../redux/hooks"
import { getInstances, getInstancesGlobales } from '../requests/request';
import axios from 'axios';
import { utils, writeFile } from 'xlsx';
import { useAuth } from '../../../auth';
const API_URL = process.env.REACT_APP_API_URL

type BGP = {
  prefix: string,
  nexthop: string,
  interfaz: string,
  life: string,
  label: string
}

type vrf = {
  vendor: string,
  vrf: string
  subscriptions: string
}

export default function BGPRoutingTable(props: any) {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)

  const { currentUser } = useAuth()

  const [Instancia, setInstancia] = useState([{ id: 0, name: " ", type: '' }])
  const [Busqueda, setBusqueda] = useState("")
  const [Datos, setDatos] = useState<BGP[]>([])
  const [listvrf, setlistvrff] = useState<vrf[]>([])
  const [vrfselect, setselectvrf] = useState<any>()

  const cambiarstate = (e: any) => {
    setBusqueda(e.target.value)
  }

  const vrfseleccionada = (e: any) => {
    setselectvrf(e.target.value)
  }

  const exportFile = useCallback(() => {
    const ws = utils.json_to_sheet(Datos);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "BGP");
    utils.sheet_add_aoa(ws, [["Prefix", "Next-hop", "Interface", "Lifetime", "Label"]], { origin: "A1" });
    writeFile(wb, "BGP Routing Table.xlsx");
  }, [Datos]);

  const handleSubmit = async (e: any) => {
    if (vrfselect !== '') {
      try {
        const vrf = listvrf[vrfselect]
        const body = { l3vrf: vrf }

        const url = tenant === 0
          ? `${API_URL}/v1/suscription/${Id}/instances/${Busqueda}/ShowIpv4BGP`
          : `${API_URL}/v1/suscription/${Id}/instances/${Busqueda}/ShowIpv4BGP?tenantId=${tenant}`

        const res = await axios.post(url, body)
        setDatos(res.data)
      } catch (error: any) {
        console.log(error)
      }
    }
  }

  const datosGlobales = async (e: any) => {
    e.preventDefault();
    if (vrfselect !== '') {
      try {
        const vrf = listvrf[vrfselect]
        const body = { l3vrf: vrf }
        const url = tenant === 0
          ? `${API_URL}/v1/suscription/-1/instances/${Busqueda}/ShowIpv4BGP`
          : `${API_URL}/v1/suscription/-1/instances/${Busqueda}/ShowIpv4BGP?tenantId=${tenant}`

        const res = await axios.post(url, body)
        setDatos(res.data)
      } catch (error: any) {
        console.log(error)
      }
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchInstances = tenant === 0
          ? Type !== 'CloudGlobal'
            ? getInstances(Id, 'Home.Networking', Type, nameregion)
            : getInstances(Id, 'Home.Networking')
          : getInstancesGlobales(Id, tenant, 'Home.Networking', Type, nameregion)

        const instancias = await fetchInstances
        if (instancias.data && instancias.data.error === 'id suscription invalido') {
          setInstancia([])
        } else {
          setInstancia(instancias.data)
          setBusqueda(instancias.data[0].id)
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error)
      }
    }
    fetchData()
  }, [Id, nameregion, props.id])

  useEffect(() => {
    const fetchVrf = async () => {
      try {
        if (Id !== 0 && Busqueda !== '') {
          const body = { instanceId: Number(Busqueda), suscriptionId: Id }
          const url = `${API_URL}/v1/listVrf?tenantId=${tenant}`
          const res = await axios.post(url, body)
          setlistvrff(res.data)
        }
      } catch {
        console.log('No se puede obtener los VRF')
      }
    }
    fetchVrf()
  }, [Busqueda, Instancia, Id])

  useEffect(() => {
    if (Type) {
      setDatos([])
    }
  }, [Type])

  useEffect(() => {
    if (Busqueda) {
      setDatos([])
    }
  }, [Busqueda])

  return (
    <div style={{ marginBottom: '15px' }} className="card card-custom border borde-gray-300">
      <div style={{ marginTop: '15px' }} className="text-marno f-titulo fs-md mb-3 text-center">
        BGP Routing Table
      </div>
      <br />
      <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 flex-center">
        <div className="d-flex flex-column flex-row-auto">
          <label className='form-label f-bold fs-p text-dk required form-label'>Instance</label>
          <select
            id="instanceSelect"
            className="custom-select"
            aria-label="Select example"
            onChange={cambiarstate}
            value={Busqueda}
          >
            {Instancia.length === 0 && (
              <option className="f-parrafo fs-p text-dk" hidden>No data</option>
            )}
            <option hidden defaultValue={0} className="f-parrafo fs-p text-dk">Select an Instance</option>
            {Id !== 0 && Instancia.map((ins, x) => (
              <option className="f-parrafo fs-p text-dk" key={x} value={ins.id}>{ins.name}</option>
            ))}
          </select>
        </div>
        <div className='w-30px'></div>
        <div className="d-flex flex-column flex-row-auto">
          <label className='form-label f-bold fs-p text-dk required form-label'>VRF</label>
          <div className="select-container">
            <select
              id="vrfSelect"
              className="custom-select"
              aria-label="Select example"
              onChange={vrfseleccionada}
              value={vrfselect}
            >
              {listvrf?.length === 0 ? (
                <option key={'x'} className="f-parrafo fs-p text-dk" hidden>No VRF</option>
              ) : (
                <option className="f-parrafo fs-p text-dk" hidden>Select a VRF</option>
              )}
              {Busqueda !== '' && Id !== 0 && Id !== -1 && listvrf.length !== 0 && listvrf?.map((vrf, i) => (
                <option className="f-parrafo fs-p text-dk" key={i} value={i}>{vrf.vrf ? vrf.vrf : 'Main'}</option>
              ))}
              {Busqueda !== '' && Type === 'CloudGlobal' && listvrf.length !== 0 && listvrf?.map((vrf, i) => (
                <option className="f-parrafo fs-p text-dk" key={i} value={i}>{vrf.vrf ? `${vrf.vrf}(${vrf.subscriptions})` : `Main(${vrf.subscriptions})`}</option>
              ))}
            </select>
          </div>
        </div>
        <div className='w-30px'></div>
        {Id !== 0 && Type !== 'CloudGlobal' && (
          <div className="d-flex flex-column flex-row-auto" style={{ marginTop: '5px' }}>
            <br />
            <button type='submit' className="btn-light-marino" onClick={handleSubmit}>
              <i className="bi bi-search" style={{ color: '#ffff' }}></i>
            </button>
          </div>
        )}
        {Type === 'CloudGlobal' && (
          <div className="d-flex flex-column flex-row-auto">
            <br />
            <button type='submit' className="btnn btn-marino" onClick={datosGlobales}>
              <i className="bi bi-search"></i>
            </button>
          </div>
        )}
        <div className='w-30px'></div>
        <div className="d-flex flex-column flex-row-auto" style={{ marginTop: '5px' }}>
          <br />
          <button className="btn-light-marino" onClick={exportFile}>
            <i className="bi bi-download" style={{ color: '#fff' }}></i> Export Excel
          </button>
        </div>
      </div>
      <br />
      <div className='card-body py-0' style={{ marginBottom: '0px', overflow: 'auto', maxHeight: '400px', paddingBottom: '10px !important' }}>
        <table className="w-full f-parrafo caption-bottom custom-table">
          <thead>
            <tr className="table-header-light bg-marino">
              <th className='w-100px text-center table-cell'>Prefix</th>
              <th className='w-125px text-center table-cell'>Next-hop</th>
              <th className='w-90px text-center table-cell'>Interface</th>
              <th className='w-10px text-center table-cell'>Lifetime</th>
              <th className='w-10px text-center table-cell'>Label</th>
            </tr>
          </thead>
          <tbody>
            {Datos?.map((d, i) => (
              <tr key={i} className="table-row">
                <td className='table-cell'>{d.prefix}</td>
                <td className='table-cell'>{d.nexthop.includes(" ") ? (
                  <>
                    {d.nexthop.split(" ")[0]}
                    <br />
                    {d.nexthop.split(" ")[1]}
                  </>
                ) : d.nexthop}</td>
                <td className='table-cell'>{d.interfaz.includes(" ") ? (
                  <>
                    {d.interfaz.split(" ")[0].split('-')[1] === undefined
                      ? d.interfaz.split(" ")[0]
                      : `VPN-${d.interfaz.split(" ")[0].split('-')[1]}-${d.interfaz.split(" ")[0].split('-')[2]}`}
                    <br />
                    {d.interfaz.split(" ")[1]}
                  </>
                ) : (
                  <p>VPN-{d.interfaz.split('-')[1]}-{d.interfaz.split('-')[2]}</p>
                )}</td>
                <td className='table-cell'>{d.life}</td>
                <td className='table-cell'>{d.label.includes(" ") ? (
                  <>
                    {d.label.split(" ")[0]}
                    <br />
                    {d.label.split(" ")[1]}
                  </>
                ) : d.label}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}